/**
 * Display settings for Storybook font scale and font family overrides.
 * In production no provider wraps the app, so hooks return system defaults.
 */

import { createContext, useContext } from 'react';
import { useWindowDimensions } from 'react-native';

interface DisplaySettings {
  fontScale: number | null;
  fontFamily: string | null;
}

export const DisplaySettingsContext = createContext<DisplaySettings>({
  fontScale: null,
  fontFamily: null,
});

/** Returns the font scale — Storybook override or system value. */
export function useFontScale(): number {
  const { fontScale } = useContext(DisplaySettingsContext);
  const { fontScale: systemFontScale } = useWindowDimensions();
  return fontScale ?? systemFontScale;
}

/** Returns the font family override, or undefined (system default). */
export function useFontFamily(): string | undefined {
  const { fontFamily } = useContext(DisplaySettingsContext);
  return fontFamily ?? undefined;
}
